import ThisModule from "./LabelCheckBox";

export default ThisModule;
